import RepositoryThemes from "./RepositoryThemes";

let resource = '';

export default {
    // get(){
    //     return Repository.get(`${resource}`);
    // },
    custom(action,payload){
        resource = action;
        return RepositoryThemes.post(`${resource}`,payload);
    },
    get(action){
        resource = action;
        return RepositoryThemes.get(`${resource}`);
    }
}